<template>
  <v-menu>
    <template #activator="{ on }">
      <v-btn
        flat
        class="mx-0 pl-1 pr-0 py-0 text-none"
        style="min-width: initial"
        v-on="on"
      >
        {{ selectedText }}
        <v-icon class="ma-0">
          arrow_drop_down
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile
        v-for="item in items"
        :key="item.value"
        @click="$emit('input', item.value)"
      >
        <v-list-tile-avatar>
          <v-icon v-if="item.value === value">
            check
          </v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'NxSearcherLimitSelector',
  props: {
    /**
     * Options that will be available.
     * @property {Number[]}
     */
    options: {
      type: Array,
      default: () => ([]),
    },
    /**
     * Current value.
     * @property Number
     */
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    items() {
      return this.options.map(value => ({
        text: this.$t('message.searcher.limit.itemsPerPage', { limit: value }),
        value,
      }));
    },
    selectedText() {
      return this.$vuetify.breakpoint.xs ? this.value : this.$tc('message.searcher.limit.itemsPerPage', this.value, { limit: this.value });
    },
  },
};
</script>
